<div class="app-container">
  @if (isLoading()) {
    <div class="global-loader-overlay">
      <fsn-loading size="large" aria-label="Carregando..." />
    </div>
  }
  <router-outlet />
</div>
